module.exports = {"230708002":"红光社区","230708003":"新兴社区","230708004":"胜利社区","230708005":"文化社区","230708006":"东林社区","230708400":"大西林林场","230708401":"五道库经营所","230708402":"缓岭经营所","230708403":"对青山经营所","230708404":"群峦经营所","230708405":"兰新经营所","230708406":"顺利河林场","230708407":"松岭经营所","230708408":"青山口林场","230708409":"金沙河林场","230708410":"桦皮羌子林场","230708411":"碧仓库林场","230708412":"三股流经营所","230708413":"卧龙河林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230708.json
// module id = 747
// module chunks = 0